import { createApiSaga } from '../../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../../middleware/api';
import {
  GET_EDIT_VOLCANO_LOCATION_REQUEST,
  CREATE_VOLCANO_LOCATION_REQUEST,
  UPDATE_VOLCANO_LOCATION_REQUEST,
  CREATE_VOLCANO_LOCATION_FAILURE,
  CREATE_VOLCANO_LOCATION_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_SUCCESS,
  UPDATE_VOLCANO_LOCATION_FAILURE,
  UPDATE_VOLCANO_LOCATION_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_COUNTRY_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_COUNTRY_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST,
  GET_EDIT_VOLCANO_LOCATION_REGION_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_REGION_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_LOCATION_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_LOCATION_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS,
  GET_EDIT_VOLCANO_LOCATION_STATUS_FAILURE,
  GET_EDIT_VOLCANO_LOCATION_STATUS_SUCCESS,
} from './volcanoLocationEditReducer';


const getVolcanoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/volcanolocs/${action.id}`, ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_FAILURE,
});

const createVolcanoSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/volcanolocs', ...action }),
  requestType: CREATE_VOLCANO_LOCATION_REQUEST,
  successType: CREATE_VOLCANO_LOCATION_SUCCESS,
  failureType: CREATE_VOLCANO_LOCATION_FAILURE,
  successMessage: 'Saved',
});

const updateVolcanoSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/volcanolocs/${action.id}`, ...action }),
  requestType: UPDATE_VOLCANO_LOCATION_REQUEST,
  successType: UPDATE_VOLCANO_LOCATION_SUCCESS,
  failureType: UPDATE_VOLCANO_LOCATION_FAILURE,
  successMessage: 'Saved',
});


const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/countries', ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_COUNTRY_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_COUNTRY_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_COUNTRY_FAILURE,
});

const getRegionsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/regions', ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_REGION_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_REGION_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_REGION_FAILURE,
});

const getStatusesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/statuses', ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_STATUS_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_STATUS_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_STATUS_FAILURE,
});

const getMorphologiesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/morphologies', ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_MORPHOLOGY_FAILURE,
});

const getEruptionTimesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/eruption-times', ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_ERUPTION_TIME_FAILURE,
});

const getLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/volcano/locations', ...action }),
  requestType: GET_EDIT_VOLCANO_LOCATION_LOCATION_REQUEST,
  successType: GET_EDIT_VOLCANO_LOCATION_LOCATION_SUCCESS,
  failureType: GET_EDIT_VOLCANO_LOCATION_LOCATION_FAILURE,
});

export const volcanoLocationEditSagas = [
  getVolcanoSaga,
  createVolcanoSaga,
  updateVolcanoSaga,
  getCountriesSaga,
  getRegionsSaga,
  getStatusesSaga,
  getMorphologiesSaga,
  getEruptionTimesSaga,
  getLocationsSaga,
];
